module.exports = __webpack_public_path__ + "static/img/sy-6.17487fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/introduce/sy-6.png
// module id = TfK1
// module chunks = 63